module.exports = "/next-static/_next/static/images/block_image_easy-f7a23cdc9f9289afc89563bc4c98f6f0.webp";